<template>
  <section class="gardenManagementPage">
    <!-- <g-breadcrumb bread="视频列表" /> -->
    <el-button type="success" @click="addType" class="turnBule">添加分类</el-button>
    <TableContainer title="">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        border
        :header-cell-style="tabHeader"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="id" label="序号" min-width="30" />
        <!-- <el-table-column prop="regDate" label="分类图" min-width="40">
          <template slot-scope="scope">
            <img :src="scope.row.catImg" width="40" height="40" />
          </template>
        </el-table-column> -->
        <el-table-column prop="catName" label="分类名称" min-width="60" />
        <el-table-column prop="catInfo" label="分类简介" min-width="60" />
        <el-table-column prop="organizationName" label="所属部门" min-width="60" />
        <el-table-column prop="createTime" label="创建时间" min-width="60" />
        <!-- <el-table-column prop="videoNum" label="视频数量" min-width="60" /> -->
        <el-table-column width="150" label="操作">
          <template slot-scope="scope">
            <el-button type="text" class="textOrange" @click="editorFormClick(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" class="textOrange" @click="delPxCatpx(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <GPagination
        v-show="total > 0"
        ref="ref_GPagination"
        :total="total"
        :page.sync="searchForm.page"
        :size.sync="searchForm.size"
        @pagination="queryPxCatPagepx"
      />
    </TableContainer>

    <!-- 新增/编辑分类s -->
    <GDialog
      :dialog.sync="catDialog"
      @btnSure="catSubmitThemeForm()"
      @btnClose="resetThemeForm()"
      width="50%"
      :showCloseBtn="false"
      :showFooter="true"
    >
      <el-form ref="ref_themeForm" label-width="100px" @submit.native.prevent>
        <div class="dis-flex flex-x-start flex-y-start">
          <div class="dis-flex flex-x-start flex-y-start">
            <p class="m-top15 col-red">*</p>
            <el-form-item label="分类名称" label-width="80px" class="t-c">
              <el-input
                v-model="pxParmas.catName"
                maxlength="35"
                placeholder="请输入分类名称"
                style="width: 210px"
                :disabled="editor == '1' ? true : false"
              />
            </el-form-item>
          </div>
          <div class="dis-flex flex-x-start flex-y-start" style="margin-left:40px">
            <p class="m-top15 col-red" >*</p>
            <el-form-item label="所属部门" label-width="80px">
              <el-select
                v-model="pxParmas.organizationId"
                placeholder="请选择部门"
                @change="(val) => partChangeType(val)"
                filterable
                allow-create
                default-first-option
                :disabled="editor == '1' ? true : false"
              >
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :label="item.organizationName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </div>
        </div>

        <el-form-item label="扩展部门" label-width="100px">
          <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="(item, index) in partList" :label="item.id">{{
              item.organizationName
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div class="dis-flex flex-x-start flex-y-start">
          <!-- <p class="m-top15 col-red">*</p> -->
          <el-form-item label="分类简介" label-width="100px">
            <textarea
              id="content"
              name="content"
              rows="10"
              cols="80"
              style="width: 100%; border: 1px solid #58e3e8"
              v-model="pxParmas.catInfo"
            ></textarea>
          </el-form-item>
        </div>
        <div class="dis-flex flex-x-start flex-y-start">
          <!-- <p class="m-top15 col-red">*</p> -->
          <el-form-item label="分类内容" label-width="100px">
            <textarea
              id="content"
              name="content"
              rows="10"
              cols="80"
              style="width: 100%; border: 1px solid #58e3e8"
              v-model="pxParmas.catContent"
            ></textarea>
          </el-form-item>
        </div>
      </el-form>
    </GDialog>
    <!--  新增/编辑分类e -->
  </section>
</template>

<script>
import {
  queryPxCatPagepx,
  delPxCat,
  selectDcDept,
  selectMinDcDept,
  addPxCatpx,
  updatePxCatpx,
  delPxCatpx,
} from "@api/bx/api_contentManagement";
import uploadPics from "@/components/Upload/uploadPics.vue";
import uploadList from "@/components/Upload/uploadList.vue";
export default {
  components: { uploadPics, uploadList },
  data() {
    return {
      tiny: {
        value: undefined,
      },
      themeDialog: {
        title: "信息框",
        visible: false,
      },
      catDialog: {
        title: "分类操作",
        visible: false,
      },
      searchForm: {
        page: 1,
        size: 10,
      },
      total: 0,
      tableData: [],
      editor: 0,
      typeList: [],
      partList: [],
      checkedCities: [],
      noticeTitle: "",
      partName: "",
      roleId: "",
      catInfo: "",
      content: "",
      pxParmas: {
        catContent: "",
        catInfo: "",
        catName: "",
        organizationId: "",
        organizationIds: "",
      },
      id: "",
    };
  },
  created() {
    this.queryPxCatPagepx();
    this.selectDcDept();
    this.selectMinDcDept();
  },
  methods: {
    tabHeader() {
      return "backgroundColor:rgba(88, 227, 232, 0.12);color:#000;font-weight:bold;font-size:15px;text-align: center;";
    },
    partChangeType() {
      console.log(this.pxParmas.organizationId);
    },

    handleCheckedCitiesChange(val) {
      console.log(val);
    },
    resetThemeForm() {
      this.editor = 0;
      this.checkedCities = [];
      this.pxParmas.catContent = "";
      this.pxParmas.catInfo = "";
      this.pxParmas.catName = "";
      this.pxParmas.organizationId = "";
      this.pxParmas.organizationIds = "";
      this.catDialog.visible = false;
    },
    // 部门列表
    selectDcDept() {
      selectDcDept({}).then((res) => {
        this.typeList = res;
      });
    },
    //多部门列表
    selectMinDcDept() {
      selectMinDcDept({}).then((res) => {
        this.partList = res;
      });
    },
    // 初始化列表
    queryPxCatPagepx() {
      queryPxCatPagepx(this.searchForm).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    //分类新增,编辑
    catSubmitThemeForm() {
      if (this.pxParmas.catName == "") {
        this.$message.warning("请填写分类名称");
        return;
      }
      if (this.pxParmas.organizationId == "") {
        this.$message.warning("请选择所属部门");
        return;
      }
      //   if (this.pxParmas.catInfo == "") {
      //     this.$message.warning("请填写分类简介");
      //     return;
      //   }
      //   if (this.pxParmas.catContent == "") {
      //     this.$message.warning("请填写分类内容");
      //     return;
      //   }

      if (this.editor == "0") {
        // return
        //首次提交
        addPxCatpx({
          catName: this.pxParmas.catName,
          catInfo: this.pxParmas.catInfo,
          catContent: this.pxParmas.catContent,
          organizationId: this.pxParmas.organizationId,
          organizationIds:
            this.checkedCities.length !== 0 ? this.checkedCities.join() : "",
        }).then((res) => {
          this.$message.success("新增分类成功");
          this.resetThemeForm();
          this.queryPxCatPagepx();

        });
      } else {
        //编辑提交
        updatePxCatpx({
          catName: this.pxParmas.catName,
          catInfo: this.pxParmas.catInfo,
          catContent: this.pxParmas.catContent,
          organizationId: this.pxParmas.organizationId,
          organizationIds:
            this.checkedCities.length !== 0 ? this.checkedCities.join() : "",
          id: this.id,
        }).then((res) => {
          this.$message.success("编辑成功");
          this.resetThemeForm();
          this.queryPxCatPagepx();
        });
      }
    },
    //添加
    addType() {
      this.catDialog.visible = true;
    },
    //编辑
    editorFormClick(row) {
      console.log(row);
      this.editor = 1;
      this.checkedCities = row.organizationIds = ""
        ? []
        : row.organizationIds.split(",").map(Number);
      console.log(this.checkedCities);
      this.pxParmas.catContent = row.catContent;
      this.pxParmas.catInfo = row.catInfo;
      this.pxParmas.catName = row.catName;
      this.pxParmas.organizationId = row.organizationId;
      this.pxParmas.organizationIds = row.organizationIds;
      this.id = row.id;
      this.catDialog.visible = true;
    },
    //删除
    delPxCatpx(row) {
      this.$confirm("永久删除【" + row.catName + "】这条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delPxCatpx({ id: row.id }).then((res) => {
          this.queryPxCatPagepx();
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
/* .tree /deep/ .el-tree-node__content{
		padding-left: 40px
	} */
.turnBule {
  color: #fff;
  background-color: #58e3e8;
  border-color: rgba(56, 185, 190, 0.12);
  margin-left: 15px;
}

.turnBule:hover,
.turnBule:focus {
  background: rgba(56, 185, 190, 0.5);
  border-color: rgba(56, 185, 190, 0.5);
  color: #fff;
}

.el-button--text.reviewed {
  color: #38b9be;
}

.reviewed {
  color: #38b9be;
}

.el-tree-node__content {
  z-index: 999;
  padding-left: 40px;
}

.directory-in {
  width: 32%;
  line-height: 60px;
  background: #4095e5;
}
</style>
